var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolsSmsSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{display:none}")), /*#__PURE__*/React.createElement("g", {
    id: "Your_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0V0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.981 40.019h32.038V7.981H7.981v32.038z",
    id: "Shopicon_00000005233862153072290020000010038958663075050425_"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolsSmsSquare);
export default __webpack_public_path__ + "static/media/symbols-sms-square.091e28c29d52af9bf696876a42497e9a.svg";
export { ForwardRef as ReactComponent };